import INotification from "@/interfaces/notification.interface";
import { FilterType, IFilter } from "@/types/filter.types";

export const initialNotificationFilterValues: IFilter<INotification>[] = [
  {
    property: "read",
    value: false,
    filterType: FilterType.Equals,
  },
];
